import React from 'react';
import { useAuth } from '../../common/context/AuthContext';
import PermissionDenied from '../../common/components/PermissionDenied';

export default function SalonPermissionRoute({ permission, children }) {
  const { hasSalonPermission } = useAuth();

  if (hasSalonPermission(permission)) {
    return children;
  }

  return (
    <PermissionDenied
      variant="card"
      title="Access Restricted"
      message="Your salon role does not have permission to open this section. Please contact your system administrator."
      onGoBack={() => window.history.back()}
    />
  );
}
